/* eslint-disable max-len */
import React from 'react';
import Grid from '@mui/material/Grid';

const CFProps = (props) => {
  const { properties, handleChangeProperties, translateObject } = props;
  const { flowPerTie, numberOfFilters, filterDP, actualFlow } = properties;
  const units = JSON.parse(localStorage.getItem('system-units')) || {};
  return (
    <div className="cf-props-container">
      <Grid container className="label-input-combined-cf">
        <Grid item xs={12} sm={5} className='no-drag-field'>
          <div className='field-text no_drag S_Bold'>{translateObject('Number of Filters')}</div>
        </Grid>
        <Grid item xs={6} sm={7} className='no-drag-field'>
          <input
            // hiddenLabel
            id="filled-hidden-label-small no_drag"
            variant="outlined"
            onChange={handleChangeProperties}
            onFocus={e => e.target.select()}
            className="Form_Input_design cf-input-props"
            style={{ width: '95%' }}
            type="number"
            name="numberOfFilters"
            value={numberOfFilters}
            disabled
          />
        </Grid>
      </Grid>
      <Grid container className="label-input-combined-cf">
        <Grid item xs={12} sm={5} className='no-drag-field'>
          <div className='field-text no_drag S_Bold'>{units.pressure ? `${translateObject('Filter DP')} (${units.pressure})` : translateObject('Filter DP')('atm')}</div>
        </Grid>
        <Grid item xs={6} sm={7} className='no-drag-field'>
          <input
            // hiddenLabel
            id="filled-hidden-label-small no_drag"
            variant="outlined"
            onChange={handleChangeProperties}
            onFocus={e => e.target.select()}
            className="Form_Input_design cf-input-props"
            style={{ width: '95%' }}
            type="number"
            name="filterDP"
            value={filterDP}
            disabled
          />
        </Grid>
      </Grid>
      <Grid container className="label-input-combined-cf">
        <Grid item xs={12} sm={5} className='no-drag-field'>
          <div className='field-text no_drag S_Bold'>{units.flow ? `${translateObject('Flow per TIE')} (${units.flow})` : translateObject('Flow per TIE')('gpm')}</div>
        </Grid>
        <Grid item xs={6} sm={7} className='no-drag-field'>
          <input
            // hiddenLabel
            id="filled-hidden-label-small no_drag"
            variant="outlined"
            onChange={handleChangeProperties}
            onFocus={e => e.target.select()}
            className="Form_Input_design cf-input-props"
            style={{ width: '95%' }}
            type="number"
            name="flowPerTie"
            value={flowPerTie}
          />
        </Grid>
      </Grid>
      <Grid container className="label-input-combined-cf">
        <Grid item xs={12} sm={5} className='no-drag-field'>
          <div className='field-text no_drag S_Bold'>{units.flow ? `${translateObject('Actual Flow per TIE')} (${units.flow})` : translateObject('Actual Flow per TIE')('gpm')}</div>
        </Grid>
        <Grid item xs={6} sm={7} className='no-drag-field'>
          <input
            // hiddenLabel
            id="filled-hidden-label-small no_drag"
            variant="outlined"
            onChange={handleChangeProperties}
            onFocus={e => e.target.select()}
            className="Form_Input_design cf-input-props"
            style={{ width: '95%' }}
            type="number"
            name="actualFlow"
            value={actualFlow}
            disabled
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default CFProps;